import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent implements AfterViewInit {
  @Input() withBackground = true;
  @Input() variant: 'primary' | 'secondary' = 'primary';
  @Input() width = 400;
  private animationDuration = 3500;
  private elementRef = inject(ElementRef);

  ngAfterViewInit(): void {
    this.startAnimationLoop();
  }

  private startAnimationLoop(): void {
    const container = this.elementRef.nativeElement.querySelector('#loader-container');
    
    setInterval(() => {
      const svg = container.querySelector('#loader-animation');
      if (svg) {
        container.removeChild(svg);
        const newSvg = svg.cloneNode(true);
        container.appendChild(newSvg);
      }
    }, this.animationDuration);
  }
}
